// Auth0's ext-param rule: the same pattern Auth0 enforces on ext-* values.
const EXT_PARAM_PATTERN = /^[-\w.*~@+ /:]{1,255}$/;

export function toValidExtParam(value: string | null): string | null {
  return value !== null && EXT_PARAM_PATTERN.test(value) ? value : null;
}
